(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('openNewTab', function($parse) {
    return {
        restrict: 'A',
        scope: '=',
        link($scope, $el, $attr) {
            const fn = $parse($attr.openNewTab);
            const el = $el[0];

            function handleRightClick(event) {
                $scope.$apply(function() {
                    if (typeof fn === 'function') {
                        fn($scope, { $event: event });
                    }
                });
            }

            el.addEventListener('contextmenu', handleRightClick);
        }
    };
});
})();
